// extracted by mini-css-extract-plugin
export default {"heading4":"heading4-module--heading4--dEueK"};